export default ({ theme: { colors } }) => ({
    height: 1,
    width: '100%',
    backgroundColor: colors.blueGrey1,
    margin: '32px 0',
});
